import * as React from 'react';
import Sider from 'antd/lib/layout/Sider';
import Menu from './Menu';
import './SideBar.scss';
import { withRouter } from 'react-router-dom';

const SideBar = (props: any) => {
	return <Sider>
	<Menu isAdmin={props.isAdmin} route={props.location.pathname} />
</Sider>
};

export default withRouter(SideBar);
